var map = {
	"./Logo_Uni_Trier_typo_neg.svg": "4bbd",
	"./ae.png": "6ba7",
	"./ae_start.png": "7d99",
	"./animation.svg": "3c21",
	"./animation/media-playback-pause-7.png": "b5d5",
	"./animation/media-playback-start-7.png": "cf1b",
	"./animation/media-seek-backward-7.png": "0ebd",
	"./animation/media-seek-backward.png": "b329",
	"./animation/media-seek-forward-7.png": "e180",
	"./animation/media-seek-forward.png": "7ff8",
	"./animation_active.svg": "e6a8",
	"./animation_inactive.svg": "5af9",
	"./archiveedition.svg": "c564",
	"./archiveedition_active.svg": "deb9",
	"./archiveedition_inactive.svg": "965c",
	"./ce_start.png": "07d9",
	"./commentary.svg": "1651",
	"./commentary_active.svg": "7724",
	"./commentary_inactive.svg": "89cc",
	"./companion.svg": "e9ea",
	"./companion_active.svg": "e234",
	"./companion_inactive.svg": "89aa",
	"./criticaledition.svg": "2bd0",
	"./criticaledition_active.svg": "9a04",
	"./criticaledition_inactive.svg": "bac1",
	"./criticaledition_introduction.svg": "3898",
	"./criticaledition_introduction_active.svg": "424a",
	"./criticaledition_matrix.svg": "13c8",
	"./criticaledition_matrix_active.svg": "1025",
	"./elaterna-header-timeline_1920x120px.jpg": "0a26",
	"./elaterna-header_1920x120px.jpg": "1417",
	"./elaterna-header_1920x60px.jpg": "6f64",
	"./elaterna_logo_web.svg": "ba2a",
	"./elaterna_logo_web_beta.svg": "8682",
	"./first.svg": "65d1",
	"./first_active.svg": "43cc",
	"./first_inactive.svg": "f5ab",
	"./help.svg": "acc2",
	"./help_active.svg": "32ba",
	"./help_inactive.svg": "d9ac",
	"./home.svg": "ac9d",
	"./home_active.svg": "8c88",
	"./home_inactive.svg": "d19a",
	"./illuminago_neg.svg": "02b2",
	"./kompetenz_logo_2016_neg.svg": "4901",
	"./last.svg": "b495",
	"./last_active.svg": "4fb0",
	"./last_inactive.svg": "6518",
	"./loading.gif": "48bf",
	"./lucerna.svg": "61db",
	"./lucerna_active.svg": "176e",
	"./lucerna_inactive.svg": "d62d",
	"./metadata.svg": "01c5",
	"./metadata_active.svg": "e18c",
	"./metadata_inactive.svg": "b8a9",
	"./movie.svg": "8795",
	"./movie_active.svg": "1a54",
	"./movie_inactive.svg": "090d",
	"./music.svg": "65ad",
	"./music_active.svg": "bb9a",
	"./music_inactive.svg": "5715",
	"./next.svg": "0043",
	"./next_active.svg": "09d1",
	"./next_inactive.svg": "e7f3",
	"./open-in-new-page-hover.png": "5f42",
	"./open-in-new-page.png": "3cf8",
	"./previous.svg": "01ed",
	"./previous_active.svg": "3dbe",
	"./screen1900_neg.svg": "0fc3",
	"./search.svg": "d103",
	"./search_active.svg": "a19f",
	"./search_inactive.svg": "3bf1",
	"./searchresult.svg": "a760",
	"./searchresult_active.svg": "2a56",
	"./searchresult_inactive.svg": "0740",
	"./slide-details.svg": "07ca",
	"./slide-details_active.svg": "9c25",
	"./slide-details_inactive.svg": "3dd6",
	"./slide-imageview.svg": "f8ba",
	"./slide-imageview_active.svg": "a5ec",
	"./slide-imageview_inactive.svg": "2c08",
	"./slide-objectview.svg": "454f",
	"./slide-objectview_active.svg": "d712",
	"./slide-objectview_inactive.svg": "eb2f",
	"./slide-relateditems.svg": "66d3",
	"./slide-relateditems_active.svg": "c031",
	"./slide-relateditems_inactive.svg": "1067",
	"./slide-text.svg": "e197",
	"./slide-text_active.svg": "2c51",
	"./slide-text_inactive.svg": "a2bd",
	"./slideset-relateditems.svg": "16e9",
	"./slideset-relateditems_active.svg": "c3fd",
	"./slideset-relateditems_inactive.svg": "6cb3",
	"./slideset-text.svg": "31d8",
	"./slideset-text_active.svg": "3a73",
	"./slideset-text_inactive.svg": "dfca",
	"./slideset.svg": "14ee",
	"./slideset_active.svg": "5a9b",
	"./slideset_inactive.svg": "6ad3",
	"./textfeld-erweitern.svg": "dae7",
	"./textfeld-schliessen.svg": "fe48",
	"./textzeile-erweitern.svg": "ec72",
	"./textzeile-schliessen.svg": "caa7",
	"./timeline/box-aufklappen-weiss.svg": "0e5d",
	"./timeline/box-schliessen-weiss.svg": "65ff",
	"./timeline/box-zuklappen-weiss.svg": "76e0",
	"./timeline/event-gelb-neu.svg": "307d",
	"./timeline/event-people-gelb-neu.svg": "f92a",
	"./timeline/event-people-rot.svg": "d846",
	"./timeline/event-rot.svg": "e521",
	"./timeline/hilfe.svg": "0618",
	"./timeline/icons-ausblenden.svg": "5278",
	"./timeline/icons-einblenden.svg": "a304",
	"./timeline/konfiguration-laden.svg": "b04d",
	"./timeline/konfiguration-speichern.svg": "6cf1",
	"./timeline/people-gelb-neu.svg": "34ab",
	"./timeline/people-rot.svg": "3529",
	"./timeline/publication-gelb-neu.svg": "450f",
	"./timeline/publication-rot.svg": "4501",
	"./timeline/technology-event-gelb-neu.svg": "943e",
	"./timeline/technology-event-rot.svg": "7a74",
	"./timeline/technology-gelb-neu.svg": "174b",
	"./timeline/technology-people-gelb-neu.svg": "6b4f",
	"./timeline/technology-people-rot.svg": "d102",
	"./timeline/technology-rot.svg": "e9ec",
	"./timeline/zeitleiste-aufklappen-blau2.svg": "ff5a",
	"./timeline/zeitleiste-aufklappen-gruen2.svg": "8d99",
	"./timeline/zeitleiste-zoom-minus.svg": "a6bc",
	"./timeline/zeitleiste-zoom-plus.svg": "2105",
	"./timeline/zeitleiste-zuklappen-blau2.svg": "8a19",
	"./timeline/zeitleiste-zuklappen-gruen2.svg": "b092",
	"./tool.svg": "b323",
	"./tool_active.svg": "8f0e",
	"./tool_inactive.svg": "1bdd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";